import RecapUnfold from "./recapUnfold";
import DataDevis from "../dataDevis";

export default class RecapUnfoldVous extends RecapUnfold {

    constructor(props) {
        super(props)
        this.bigTitle = 'Vérifier vos informations'
        this.title = 'Vous'
        this.modifyPage = 'vous'
    }

    doRender() {
        const {devis} = this.props
        const {params} = devis
        const need_A2 = devis.need_A2()
        const permis_B = params.categorie_permis == 'B'
        const permis_A2 = params.categorie_permis == 'A2'
        const sinistres = devis.getSinistres()

        return <>
        <label><b>Adresse</b>
            <span>{this.value('prenom')} {this.value('nom')}<br/>{this.value('adresse2')} {this.value('adresse')}<br/>{this.value('code_postal')} {this.value('ville')}</span>
        </label>
        
        {this.staticLabel("telephone")}
        {this.staticLabel("email")}
        {this.staticLabel("date_naissance")}
        <label><b>Votre permis</b>
            <span>{this.value('categorie_permis')} ({this.value('norme_permis')})</span>
        </label>
        {this.staticLabel("date_obtention_permis",{forceLabel:'Obtenu le'})}
        {need_A2 ? <>
            {this.staticLabel("aussi_permis_A2",{forceDisplay:true})}
            {this.staticLabel("date_obtention_permis_A2",{forceDisplay:true})}
        </>:''}
        {permis_A2 ? this.staticLabel("bridee_47_5CV") :''}
        {permis_B ? this.staticLabel("formation_F125",{forceLabel:'Vous remplissez les conditions pour conduire ce véhicule avec le permis B',forceDisplay:true}) : ''}
        {need_A2 ? this.staticLabel('permis_A_obtenu_par_formation') : ''}

        {this.staticLabel("antecedant_400cm3_24mois")}
        {this.staticLabel("assure_actuellement")}

        <label><b>Bonus moto / auto</b><span>{this.value('coefficient_moto',100)} / {this.value('coefficient_auto',100)}</span></label>
        {(( this.value('coefficient_moto')<=50 )||( this.value('coefficient_auto')<=50 ))
        ?this.staticLabel("bonus_50_plus_3_ans",{forceDisplay:true})
        :''}
        <label><b>Situation familiale</b><span>{this.value('situation_famille')}, {this.value('nombre_enfants','0')} enfants</span></label>

        {this.staticLabel("ant_retrait")}
        {this.staticLabel("ant_annulation")}
        {this.staticLabel("ant_alcool")}
        {this.staticLabel("ant_stupefiants")}
        {this.staticLabel("ant_resiliation")}
        {/*( sinistres.length > 0 )?<><label><u>Sinistres avec ce véhicule :</u></label></>:<></>*/}
        {sinistres.map(
            ( sinistre, idx ) => <label key={idx}>{sinistre.date} : <span>{DataDevis.sinistreTypeToDisplay[sinistre.type]}</span></label>
        )}
        {((params['ant_retrait']=='N')
            &&(params['ant_annulation']=='N')
            &&(params['ant_alcool']=='N')
            &&(params['ant_stupefiants']=='N')
            &&(params['ant_resiliation']=='N')
            &&( sinistres.length == 0 ))?<label><b>Aucun antécédent (retrait / sancion / sinistre...)</b></label>:''}

        </>

    }
}